/* Add route composer helper functions here */
import {
  cohortUrls,
  startupUrls,
  peopleUrls,
  serviceProvidersUrls,
  requestUrls,
  partnerUrls,
  performanceUrls,
  servicesUrl,
  walletUrl,
  angelInvestorUrls,
  angelInvestorWalletUrl,
  articlesUrl,
  technicalLicenseHolderUrls,
  ventureBuilderUrls,
} from './urls'

export const composeCohortsDetailsUrl = (id: number) => `${cohortUrls.cohortsDetailUrl}/${id}`;

export const composeEditCohortUrl = (id: number) => `${cohortUrls.editCohortUrl}/${id}`;

export const composeStartupDetailsUrl = (id: number | string) => `${startupUrls.startupDetailsUrl}/${id}`;

export const composeAngelInvestorDetailsUrl = (
  id: number | string,
) => `${angelInvestorUrls.angelInvestorDetailsUrl}/${id}`;

export const composeEditStartupUrl = (id: number) => `${startupUrls.editStartupUrl}/${id}`;

export const composeEditAngelInvestorUrl = (id: number) => `${angelInvestorUrls.editAngelInvestorUrl}/${id}`;

export const composeTechnicalLicenseDetailsUrl = (id: number) => `${technicalLicenseHolderUrls.technicalLicenseHolderDetailsUrl}/${id}`

export const composeVentureBuilderDetailsUrl = (id: number) => `${ventureBuilderUrls.ventureBuilderDetailsUrl}/${id}`;

export const composeEditTechnicalLicenseUrl = (id: number) => `${technicalLicenseHolderUrls.editTechnicalLicenseHolderUrl}/${id}`;

export const composeEditPeopleUrl = (id: number, personType: string) => `${peopleUrls.editPeopleUrl}/${personType}/${id}`;

export const composeEditServiceProviderUrl = (id: number) => `${serviceProvidersUrls.editServiceProviderUrl}/${id}`;

export const composePeopleDetailsUrl = (id: number, personType: string) => `${peopleUrls.peopleDetailsUrl}/${personType}/${id}`;

export const composeServiceProviderDetailsUrl = (id: number) => `${serviceProvidersUrls.serviceProviderDetailsUrl}/${id}`;

export const composeServiceProviderMoreDetailsUrl = (id: number) => `${serviceProvidersUrls.serviceProviderMoreDetailsUrl}/${id}`;

export const composeRequestMoreDetailsUrl = (id: number) => `${requestUrls.requestMoreDetailsUrl}/${id}`;

export const composePartnerDetailsUrl = (id: number) => `${partnerUrls.partnerDetailsUrl}/${id}`;

export const composeEditPartnerDetailsUrl = (id: number) => `${partnerUrls.editPartnerUrl}/${id}`;

export const composeEditPerformanceReportUrl = (id: number) => `${performanceUrls.editPerformanceReportUrl}/${id}`;

export const composeServiceOverview = (id: number) => `${servicesUrl}/${id}`;

export const composeArticlesUrl = (id: number) => `${articlesUrl}/${id}`;

export const composeStartupWalletUrl = (id: number | string) => `${walletUrl}/${id}`;

export const composeAngelInvestorWalletUrl = (id: number | string) => `${angelInvestorWalletUrl}/${id}`;
